import { createReducer } from '@mews/framework';
import {
    META_STATE_STARTED,
    META_STATE_FAILED,
    META_STATE_SUCCEEDED,
} from '@mews-commander/legacy-entities/src/constants';
import {
    RESOURCE_ASSIGNMENT_FORM_INIT_FAILED,
    RESOURCE_ASSIGNMENT_FORM_INIT_STARTED,
    RESOURCE_ASSIGNMENT_FORM_INIT_SUCCEEDED,
} from './actions';

export default createReducer(
    { ...META_STATE_SUCCEEDED },
    {
        [RESOURCE_ASSIGNMENT_FORM_INIT_SUCCEEDED]: () => ({
            ...META_STATE_SUCCEEDED,
        }),
        [RESOURCE_ASSIGNMENT_FORM_INIT_STARTED]: () => ({
            ...META_STATE_STARTED,
        }),
        [RESOURCE_ASSIGNMENT_FORM_INIT_FAILED]: () => ({
            ...META_STATE_FAILED,
        }),
    }
);
